import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import s from '../BlockFlow/blockProfile.module.scss';
import { Divider } from '@components/UIKit/Divider/Divider';
interface IUnblockSuccessStepProps {
  onComplete: () => void;
  authorName: string;
}
export const UnblockSuccessStep = ({
  onComplete,
  authorName
}: IUnblockSuccessStepProps) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.container} data-sentry-component="UnblockSuccessStep" data-sentry-source-file="UnblockSuccessStep.tsx">
			<div className={s.container__header}>
				<h3 className={s.container__header_title}>
					{tr({
          id: 'unblock.success.title'
        }, {
          author: authorName
        })}
				</h3>
			</div>

			<p className={s.container__text}>
				{tr({
        id: 'unblock.success.description'
      }, {
        author: authorName
      })}
			</p>

			<Divider data-sentry-element="Divider" data-sentry-source-file="UnblockSuccessStep.tsx" />

			<div className={s.container__buttons}>
				<Button id='default_button' onClick={onComplete} color='Black' size='medium' data-sentry-element="Button" data-sentry-source-file="UnblockSuccessStep.tsx">
					{tr({
          id: 'btn.ok'
        })}
				</Button>
			</div>
		</div>;
};